import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "dialog-head-font font-weight-700 ellipsis-1-line",
    style: { "max-width": "calc(100% - 37px)" }
};
const _hoisted_2 = {
    class: "text-body2 font-weight-700 ellipsis-1-line",
    style: { "max-width": "calc(100% - 37px)" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_toolbar = _resolveComponent("q-toolbar");
    const _component_q_bar = _resolveComponent("q-bar");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createBlock(_component_q_dialog, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.showModal) = $event)),
        class: _normalizeClass(["general-dialog", {
                'full-dialog-align': _ctx.maximized,
                'no-max-width': _ctx.width !== undefined
            }]),
        maximized: _ctx.maximized,
        persistent: _ctx.persistent,
        position: _ctx.position,
        "transition-show": _ctx.disableTransition ? '' : _ctx.showTransition,
        "transition-hide": _ctx.disableTransition ? '' : _ctx.hideTransition,
        ref: "generalDialogRef",
        onHide: _ctx.checkPersistence,
        onShow: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('show')))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "card", {}, () => [
                _createVNode(_component_q_card, {
                    style: _normalizeStyle({
                        width: _ctx.size === '100vw' ? _ctx.size : _ctx.width || _ctx.size,
                    }),
                    class: _normalizeClass([{
                            ..._ctx.customCardClass,
                            'smooth-scroll': !_ctx.disableSmoothScroll,
                            'max-vp-ht': _ctx.maximized
                        }, "full-page-max-width dialog-wrap"]),
                    ref: "cardRef",
                    onTouchstart: _ctx.touchDetect,
                    onTouchmove: _ctx.touchMove,
                    onClick: _ctx.dialogClick,
                    onScroll: _ctx.emitScroll
                }, {
                    default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            ref: "header",
                            class: _normalizeClass(["sticky z-4", { ..._ctx.bgColor }]),
                            style: _normalizeStyle(_ctx.stickyHeaderStyle)
                        }, [
                            _renderSlot(_ctx.$slots, "title-toolbar", {}, () => [
                                (_ctx.toolbarHeader)
                                    ? (_openBlock(), _createBlock(_component_q_toolbar, {
                                        key: 0,
                                        class: _normalizeClass({
                                            ..._ctx.bgColor,
                                        })
                                    }, {
                                        default: _withCtx(() => [
                                            _renderSlot(_ctx.$slots, "title", {}, () => [
                                                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1)
                                            ]),
                                            (!_ctx.hideBtn)
                                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                                    key: 0,
                                                    flat: "",
                                                    round: "",
                                                    dense: "",
                                                    name: "Close",
                                                    icon: "close",
                                                    size: "12px",
                                                    class: _normalizeClass(_ctx.closeBtnStandardClass),
                                                    style: _normalizeStyle({
                                                        ..._ctx.closeBtnStandardStyle,
                                                        height: '25px',
                                                        top: '12px',
                                                    }),
                                                    onClick: _ctx.closeModelFunc
                                                }, null, 8, ["class", "style", "onClick"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 3
                                    }, 8, ["class"]))
                                    : (!_ctx.toolbarHeader)
                                        ? (_openBlock(), _createBlock(_component_q_bar, {
                                            key: 1,
                                            class: _normalizeClass({
                                                ..._ctx.bgColor,
                                                'justify-center': _ctx.title,
                                                'justify-end': !_ctx.title,
                                            }),
                                            style: { "height": "36px !important" }
                                        }, {
                                            default: _withCtx(() => [
                                                _renderSlot(_ctx.$slots, "title", {}, () => [
                                                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
                                                ]),
                                                (!_ctx.hideBtn)
                                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                                        key: 0,
                                                        flat: "",
                                                        round: "",
                                                        dense: "",
                                                        name: "Close",
                                                        icon: "close",
                                                        class: _normalizeClass(_ctx.closeBtnStandardClass),
                                                        size: _ctx.leanHeader ? '14px' : '16px',
                                                        style: _normalizeStyle(_ctx.closeBtnStandardStyle),
                                                        onClick: _ctx.closeModelFunc
                                                    }, null, 8, ["class", "size", "style", "onClick"]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 3
                                        }, 8, ["class"]))
                                        : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createVNode(_component_q_separator, null, null, 512), [
                                [_vShow, !_ctx.hideHeaderSeparator && !_ctx.hideHeader]
                            ])
                        ], 6), [
                            [_vShow, !_ctx.hideHeader]
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["dialog-wrap", {
                                    ..._ctx.customSectionClass
                                }]),
                            ref: "dialogContentRef",
                            style: _normalizeStyle({
                                ..._ctx.customSectionStyle,
                            }),
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.resizeObserverMethod && _ctx.resizeObserverMethod(...args)))
                        }, [
                            _createElementVNode("div", {
                                ref: "fixed",
                                style: _normalizeStyle({
                                    ..._ctx.customSectionStyle,
                                }),
                                class: _normalizeClass({
                                    ..._ctx.customSectionClass,
                                })
                            }, [
                                _renderSlot(_ctx.$slots, "content-sections", {}, () => [
                                    _createVNode(_component_q_card_section, {
                                        class: _normalizeClass(["cart", {
                                                'q-pa-sm': !_ctx.disableBasePadding,
                                                'q-pa-none': _ctx.disableBasePadding,
                                            }])
                                    }, {
                                        default: _withCtx(() => [
                                            _renderSlot(_ctx.$slots, "content")
                                        ]),
                                        _: 3
                                    }, 8, ["class"])
                                ])
                            ], 6),
                            _createElementVNode("div", {
                                ref: "bottom",
                                class: _normalizeClass(["z-high sticky-bottom", {
                                        'white-dark-background': !_ctx.customStickyColor,
                                        [_ctx.customStickyColor || '']: true
                                    }])
                            }, [
                                _renderSlot(_ctx.$slots, "additional-section")
                            ], 2)
                        ], 6)
                    ]),
                    _: 3
                }, 8, ["style", "class", "onTouchstart", "onTouchmove", "onClick", "onScroll"])
            ])
        ]),
        _: 3
    }, 8, ["modelValue", "class", "maximized", "persistent", "position", "transition-show", "transition-hide", "onHide"]));
}
